export default __webpack_public_path__ + "static/media/quad_bottom.1b17a70a.svg";